module.exports = __webpack_public_path__ + "img/cs-iosC-3.d446aea0.jpg";